<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center">
                        <div class="title col-sm-6">
                            <h3> It Asset </h3>
                        </div>
                        <div class="col-sm-6" style="display: flex; justify-content: flex-end; align-items: center;">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                                <button type="button" title="Edit" (click)="updateBtApp()">
                                    <span><i class="ri-pencil-line"></i></span>  
                                </button>
                            </div>
                            <div class="delete" *ngIf="selectedCheckboxData.length > 0">
                                <button type="button" title="Delete" data-bs-toggle="modal" data-bs-target="#deleteItAsset" (click)="deleteOpenModal()">
                                    <span><i class="ri-delete-bin-5-line"></i></span> 
                                </button>
                            </div>
                            <div>
                                <button type="button" (click)="openbaApp()" title="Create" class="btn btn-icon">
                                    <i class="ri-add-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <ag-grid-angular
                         style="height: calc(100vh - 120px) !important;" 
                         class="ag-theme-material"
                        (gridReady)="onGridReady($event)" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        pagination="true" 
                        [defaultColDef]="defaultColDef"
                        [suppressRowClickSelection]="true"
                        [rowSelection]="rowSelection"
                        (selectionChanged)="onSelectionChanged($event)"
                        paginationPageSize=10
                        >
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Create new ItAsset -->
<div class="modal fade" id="createItAsset" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="itassetForm">
                <div class="modal-header">
                    <h5 class="modal-title" *ngIf="modeAction === 1" >Create IT Asset</h5>
                    <h5 class="modal-title" *ngIf="modeAction === 2" >Update IT Asset</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="assetType" type="text" required>
                            <label for="assetType" class="floating-label">Asset Type</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.assetType.touched && f.assetType.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.assetType.errors.required">Asset Type is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="assetId" type="text" required>
                            <label for="assetId" class="floating-label">Asset Id</label>
                            <i class="ri-user-follow-line"></i>
                        </div>
                        <mat-error *ngIf="f.assetId.touched && f.assetId.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.assetId.errors.required">Asset Id is required</mat-error>
                            <mat-error *ngIf="f.assetId.errors.pattern">Asset Id can contain AlphaNumeric characters</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="macId" type="text" required>
                            <label for="macId" class="floating-label">Mac Id</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <label class="floating-label"></label>
                                <input list="userList" formControlName="user" placeholder=" Select User">
                                <datalist id="userList">
                                    <option [value]="item" *ngFor="let item of userDropdownList">
                                </datalist>
                            <i class="ri-file-copy-2-line"></i>
                        </div>
                        <mat-error *ngIf="f.user.touched && f.user.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.user.errors.required">User is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="department" type="text" required>
                            <label for="department" class="floating-label">Department</label>
                            <i class="ri-file-list-3-line"></i>
                        </div>
                        <mat-error *ngIf="f.department.touched && f.department.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.department.errors.required">Department is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="model" type="text" required>
                            <label for="model" class="floating-label">Make-Model</label>
                            <i class="ri-list-ordered"></i>
                        </div>
                        <mat-error *ngIf="f.model.touched && f.model.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.model.errors.required">Model is required</mat-error>
                            <mat-error *ngIf="f.model.errors.pattern">Model can contain AlphaNumeric characters</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="sn" type="text" required>
                            <label for="sn" class="floating-label">SN</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.sn.touched && f.sn.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.sn.errors.required">SN is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="pn" type="text" required>
                            <label for="pn" class="floating-label">PN</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="warranty" type="date" required>
                            <label for="warranty" class="floating-label">Warranty</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="installDate" type="date" required>
                            <label for="" class="floating-label">Install Date</label>
                            <i class="ri-calendar-check-line"></i>
                        </div>
                        <mat-error *ngIf="f.installDate.touched && f.installDate.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.installDate.errors.required">Install Date is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="os" type="text" required>
                            <label for="os" class="floating-label">OS</label>
                            <i class="ri-shield-user-line"></i>
                        </div>
                        <mat-error *ngIf="f.os.touched && f.os.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.os.errors.required">OS is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="vendor" type="text" required>
                            <label for="vendor" class="floating-label">Vendor</label>
                            <i class="ri-user-2-line"></i>
                        </div>
                        <mat-error *ngIf="f.vendor.touched && f.vendor.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.vendor.errors.required">Vendor is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="location" type="text" required>
                            <label for="location" class="floating-label">Location</label>
                            <i class="ri-map-pin-line"></i>
                        </div>
                        <mat-error *ngIf="f.location.touched && f.location.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.location.errors.required">Location is required</mat-error>
                        </mat-error>
                    </div>
                    <div class="input">
                        <div class="input-item">
                            <input formControlName="configuration" type="text" required>
                            <label for="configuration" class="floating-label">Configuration</label>
                            <i class="ri-list-settings-line"></i>
                        </div>
                        <mat-error *ngIf="f.configuration.touched && f.configuration.invalid" class="alert alert-danger">
                            <mat-error *ngIf="f.configuration.errors.required">Configuration is required</mat-error>
                        </mat-error>
                    </div>
                    

                </div>
                <div class="modal-footer">
                    <button type="button" id="closeCreateModal" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 1" (click)="createItAsset()" [disabled]="!itassetForm.valid">Create</button>
                    <button type="button" class="btn btn-primary" *ngIf="modeAction === 2" (click)="updateItAsset()" [disabled]="!itassetForm.valid">Update</button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete an item -->
<div class="modal fade" id="deleteItAsset" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form action="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure want to delete?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                    <div class="text-center">
                        <p>{{deleteConfirmationMsg}}?</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button id="closeModalDeleteItAsset" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary" *ngIf="selectedCheckboxData.length > 0" (click)="deleteItAssetList()">Yes Delete</button>
                </div>
            </form>
        </div>
    </div>
</div> 